/* eslint-disable no-undef */
function createSvgFromCanvas (canvasToConvert) {
    let svg = canvasToConvert.toSVG().toString().replace(/&(?!amp;)/g, '&amp;');
    let encodeSVG = encodeURIComponent(svg);
    return encodeSVG;
}

export function generateSvgForOTP (optionSelected) {
    let svgAllFormat = {};
    let newIconOptions = {};
    let newCanvas = new fabric.StaticCanvas('rebuildCanvas');
    newCanvas.setWidth(optionSelected.originalImage.width);
    newCanvas.setHeight(optionSelected.originalImage.height);

    let newCanvasImg = new fabric.Image(optionSelected.originalImage.image, {
        left: 0,
        top: 0
    });
    let newTextOptions = {
        top: optionSelected.textCoordinateY,
        left: optionSelected.textCoordinateX,
        fill: optionSelected.colorCode,
        fontFamily: optionSelected.fontFamilyCode,
        angle: optionSelected.rotate,
        fontSize: optionSelected.originalImage.height * 0.04 * optionSelected.fontScaled,
        lineHeight: optionSelected.originalImage.height * 0.08,
        height: optionSelected.originalImage.height * 0.08,
        textAlign: 'center',
        width: optionSelected.rectWidth
    };
    let text = optionSelected.text;
    let newCanvasText = new fabric.Text(text, newTextOptions);
    let newCanvasIcon;

    if (optionSelected.iconImage) {
        let isBold = optionSelected.fontFamilyCode.toLowerCase().includes('bold');
        let extraSpacingForWideChars = 0;
        if (optionSelected.fontFamilyCode === 'parisienneRegular') {
            extraSpacingForWideChars = 100;
        }

        if (text === text.toUpperCase()) {
            extraSpacingForWideChars += 40;
        }

        for (var i = 0; i < text.length; i++) {
            if (/[WM]/.test(text.charAt(i))) {
                extraSpacingForWideChars += 30;
            }
            if (/[A-VXYZ]/.test(text.charAt(i))) {
                extraSpacingForWideChars += 20;
            }
            if (/[wm]/.test(text.charAt(i))) {
                extraSpacingForWideChars += 25;
            }
            if (isBold) {
                extraSpacingForWideChars += 20;
            }
        }
        newIconOptions = {
            height: optionSelected.iconImage.height,
            width: optionSelected.iconImage.width,
            top: optionSelected.iconCoordinateY,
            left: optionSelected.iconCoordinateX + extraSpacingForWideChars,
            angle: optionSelected.iconImage.angle,
            scaleX: optionSelected.iconImage.scaleX,
            scaleY: optionSelected.iconImage.scaleY
        };

        newCanvasIcon = new fabric.Image(optionSelected.iconImage.image, newIconOptions);
    }

    // ONLY TEXT SVG
    newCanvas.add(newCanvasText);
    if (newCanvasIcon) newCanvas.add(newCanvasIcon);
    svgAllFormat.personalizationTextSVG = createSvgFromCanvas(newCanvas);

    // FULL IMAGE AND TEXT SVG
    newCanvas.remove(newCanvasText);
    if (newCanvasIcon) newCanvas.remove(newCanvasIcon);
    newCanvas.add(newCanvasImg);
    if (newCanvasIcon) newCanvas.add(newCanvasIcon);
    newCanvas.add(newCanvasText);
    svgAllFormat.personalizationFullSVG = createSvgFromCanvas(newCanvas);

    // HALF SIZE SVG
    let scaleRatio = Math.min(0.5);
    newCanvas.setDimensions({ width: newCanvas.getWidth() * scaleRatio, height: newCanvas.getHeight() * scaleRatio });
    newCanvas.setZoom(scaleRatio);
    svgAllFormat.personalizationSmallSVG = createSvgFromCanvas(newCanvas);

    return svgAllFormat;
}
